
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/el-temps/[slug]",
      function () {
        return require("private-next-pages/3catinfo/el-temps/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/el-temps/[slug]"])
      });
    }
  